import React from 'react'
import PropTypes from 'prop-types'

export function BuildingTypeSelector({ types, selectedId, onSelect }) {
  return (
    <div className="building-type-options">
      {types.map(type => (
        <button
          key={type.id}
          type="button"
          className={`building-type-option${
            selectedId?.toLowerCase() === type.id?.toLowerCase()
              ? ' building-type-selected'
              : ''
          }`}
          onClick={() => onSelect(type.id)}>
          {type.icon}
          <span>{type.label}</span>
        </button>
      ))}
    </div>
  )
}

BuildingTypeSelector.propTypes = {
  types: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      icon: PropTypes.node,
    })
  ).isRequired,
  selectedId: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
}
